/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar/mn_MN';
import DatePicker from './date-picker/mn_MN';
import Pagination from './pagination/mn_MN';
import TimePicker from './time-picker/mn_MN';

export default {
  locale: 'mn-mn',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Ð¥Ð°Ð¹Ñ ÑÑÑ',
    filterConfirm: 'OK',
    filterReset: 'Ð¦ÑÐ²ÑÑÐ»ÑÑ',
    selectAll: 'ÐÒ¯Ð³Ð´Ð¸Ð¹Ð³ ÑÐ¾Ð½Ð³Ð¾Ñ',
    selectInvert: 'ÐÑÑÐ´ÑÐ³ ÑÐ¾Ð½Ð³Ð¾Ñ'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Ð¦ÑÑÐ»Ð°Ñ',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Ð¦ÑÑÐ»Ð°Ñ'
  },
  Transfer: {
    searchPlaceholder: 'Ð¥Ð°Ð¹Ñ',
    itemUnit: 'ÐÒ¯Ð¹Ð»',
    itemsUnit: 'ÐÒ¯Ð¹Ð»Ò¯Ò¯Ð´'
  },
  Upload: {
    uploading: 'Ð¥ÑÑÐ»Ð¶ Ð±Ð°Ð¹Ð½Ð°...',
    removeFile: 'Ð¤Ð°Ð¹Ð» ÑÑÑÐ³Ð°Ñ',
    uploadError: 'Ð¥ÑÑÐ»Ð°ÑÐ°Ð´ Ð°Ð»Ð´Ð°Ð° Ð³Ð°ÑÐ»Ð°Ð°',
    previewFile: 'Ð¤Ð°Ð¹Ð»ÑÐ³ ÑÒ¯ÑÐ³ÑÐ½ Ò¯Ð·ÑÑ'
  },
  Empty: {
    description: 'ÐÑÐ´ÑÑÐ»ÑÐ» Ð±Ð°Ð¹ÑÐ³Ò¯Ð¹ Ð±Ð°Ð¹Ð½Ð°'
  }
};
